import { render, staticRenderFns } from "./EditAddDxCode.vue?vue&type=template&id=a226c2ea&scoped=true"
import script from "./EditAddDxCode.vue?vue&type=script&lang=js"
export * from "./EditAddDxCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226c2ea",
  null
  
)

export default component.exports